/* eslint-disable import/no-named-as-default */
/* eslint-disable react/prop-types */
import { Button, Modal } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import SelectProposedDateStep, { COLLECTION_DATE_OTHER_OPTION } from './components/SelectProposedDateStep';
import SelectGarageStep from './components/SelectGarageStep';
import SuccessStep from './components/SuccessStep';
import SelectOtherDateStep from './components/SelectOtherDateStep';
import ModalLoadingOverlay from '$app/shared/components/ModalLoadingOverlay';
import sendConfirmRescheduleRequest from './api';
import BookingPageContext from '../../../context';

const RescheduleConfirmModal = ({ booking }) => {
  const { reloadBooking } = useContext(BookingPageContext);
  const [currentStep, setCurrentStep] = useState('SelectProposedDate');
  const [modalTitle, setModalTitle] = useState(null);
  const [canShowNext, setCanShowNext] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmRescheduleButtonVisible, setConfirmRescheduleButtonVisible] = useState(true);
  const [isModalVisible, setModalVisible] = useState(false);
  const [dateOptionSelected, setDateOptionSelected] = useState('');
  const [invitationId, setInvitationId] = useState(undefined);

  const SELECT_PROPOSED_DATE = 'SelectProposedDate';
  const SELECT_GARAGE = 'SelectGarage';
  const SELECT_OTHER_DATE = 'SelectOtherDate';
  const SUCCESS = 'Success';

  const { garageInvites, bookingId } = booking;

  const handleDateOptionSelected = (date) => {
    setDateOptionSelected(date);
    setCanShowNext(true);
  };

  const handleGarageInvitationSelected = (selectedInvitationId) => {
    setInvitationId(selectedInvitationId);
    setCanShowNext(true);
  };

  const steps = {
    [SELECT_PROPOSED_DATE]: {
      modalTitle: 'What date should we allocate the customers booking to?',
      render: () => (
        <SelectProposedDateStep
          dateOptionSelected={dateOptionSelected}
          garageInvites={garageInvites}
          handleDateOptionSelected={handleDateOptionSelected}
        />
      ),
    },
    [SELECT_GARAGE]: {
      modalTitle: 'What garage should we allocate the booking to?',
      render: () => (
        <SelectGarageStep
          garageInvites={garageInvites}
          dateOptionSelected={dateOptionSelected}
          invitationId={invitationId}
          handleGarageInvitationSelected={handleGarageInvitationSelected}
        />
      ),
    },
    [SELECT_OTHER_DATE]: {
      modalTitle: 'Change collection date',
      render: () => (
        <SelectOtherDateStep
          originalCollectionDateTime={booking.collectionDateTimeLocal}
          dateOptionSelected={dateOptionSelected}
          handleDatePickerSelected={handleDateOptionSelected}
        />
      ),
    },
    [SUCCESS]: {
      modalTitle: null,
      // eslint-disable-next-line no-use-before-define
      render: () => <SuccessStep handleCancel={handleCancel} />,
    },
  };

  const setStep = (stepKey) => {
    const step = steps[stepKey];
    setCurrentStep(stepKey);
    setModalTitle(step.modalTitle);
    setCanShowNext(false); // the next button should be disabled by default at the start of every step
  };

  const currentStepIs = (stepKey) => currentStep === stepKey;

  const handleCancel = () => {
    setDateOptionSelected('');
    setModalVisible(false);
    setStep(SELECT_PROPOSED_DATE);

    if (currentStepIs(SUCCESS)) reloadBooking();
  };

  const onNextButtonClick = async () => {
    if (currentStepIs(SELECT_PROPOSED_DATE)) {
      if (dateOptionSelected === COLLECTION_DATE_OTHER_OPTION) {
        setStep(SELECT_OTHER_DATE);
      } else {
        setStep(SELECT_GARAGE);
      }
    }

    if (currentStepIs(SELECT_GARAGE) || currentStepIs(SELECT_OTHER_DATE)) {
      setIsLoading(true);
      await sendConfirmRescheduleRequest(bookingId, dateOptionSelected, invitationId);
      setIsLoading(false);
      setStep(SUCCESS);
    }

    if (currentStepIs(SUCCESS)) {
      setConfirmRescheduleButtonVisible(false);
      setModalVisible(false);
    }
  };

  const ModalContent = ({ currentStep }) => steps[currentStep].render();

  useEffect(() => {
    setStep(SELECT_PROPOSED_DATE); // Set default step
  }, []);

  return (
    <>
      {isConfirmRescheduleButtonVisible && (
        <Button style={{ margin: '10px' }} type="primary" onClick={() => setModalVisible(true)}>
          Select reschedules
        </Button>
      )}
      <Modal
        visible={isModalVisible}
        title={modalTitle}
        width="550px"
        onCancel={handleCancel}
        footer={
          !currentStepIs(SUCCESS) && [
            <Button key="back" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={onNextButtonClick} disabled={!canShowNext}>
              Next
            </Button>,
          ]
        }
      >
        {isLoading && <ModalLoadingOverlay />}
        <ModalContent currentStep={currentStep} />
      </Modal>
    </>
  );
};

export default RescheduleConfirmModal;
